import api from './api';

const profitDistributionService = {
  // Get profit data for a specific month
  getMonthProfitData: async (month) => {
    const response = await api.get(`/profit-distribution/month-data/${month}`);
    return response.data;
  },

  // Get all distributions
  getAllDistributions: async (params = {}) => {
    const response = await api.get('/profit-distribution', { params });
    return response.data;
  },

  // Get distribution by month
  getDistributionByMonth: async (month) => {
    const response = await api.get(`/profit-distribution/month/${month}`);
    return response.data;
  },

  // Get last distribution (for copying)
  getLastDistribution: async () => {
    const response = await api.get('/profit-distribution/last-distribution');
    return response.data;
  },

  // Create new distribution
  createDistribution: async (data) => {
    const response = await api.post('/profit-distribution', data);
    return response.data;
  },

  // Update distribution
  updateDistribution: async (id, data) => {
    const response = await api.put(`/profit-distribution/${id}`, data);
    return response.data;
  },

  // Approve distribution
  approveDistribution: async (id) => {
    const response = await api.put(`/profit-distribution/${id}/approve`, {});
    return response.data;
  },

  // Cancel distribution
  cancelDistribution: async (id) => {
    const response = await api.put(`/profit-distribution/${id}/cancel`, {});
    return response.data;
  },

  // Mark employee incentive as paid
  markIncentivePaid: async (id, data) => {
    const response = await api.put(`/profit-distribution/incentive/${id}/pay`, data);
    return response.data;
  },

  // Bulk mark incentives as paid
  bulkMarkPaid: async (data) => {
    const response = await api.post('/profit-distribution/incentive/bulk-pay', data);
    return response.data;
  },

  // Get employee incentive history
  getEmployeeIncentiveHistory: async (userId, limit = 12) => {
    const response = await api.get(`/profit-distribution/employee/${userId}/incentives`, {
      params: { limit }
    });
    return response.data;
  },

  // Get summary report
  getSummaryReport: async (startMonth, endMonth) => {
    const response = await api.get('/profit-distribution/summary', {
      params: { startMonth, endMonth }
    });
    return response.data;
  }
};

export default profitDistributionService;
